import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import styled from "styled-components";
import { returnEuroString } from "../../../helpers/Utils";
import { Checkbox, Tooltip } from "antd";
import { IconDot } from "../../Layout/Icons";
import { assignSupplierName } from "../../../utils/tch";
import { MdAddCircle } from "react-icons/md";
import VvSkuPopover from "./VvSkuPopover";
import OnHoldBadge from "../../common/OnHoldBadge";


function TableColumnProduct(props) {
  const product_suppliers = Array.isArray(props.item.product_suppliers)
    ? props.suppliers.length > 0
      ? props.item.product_suppliers.filter((d) =>
        props.suppliers.includes(d.supplier_id)
      )
      : props.item.product_suppliers
    : [];

  const quantities = product_suppliers.reduce(
    (acc, currentValue) => {
      const supplierName = currentValue?.supplier?.name?.toLowerCase();
      if (supplierName === "rivile") {
        acc.rivile += currentValue?.quantity;
      } else {
        acc.bb += currentValue?.quantity;
      }
      return acc;
    },
    { rivile: 0, bb: 0 }
  );
  quantities.other = quantities.bb + quantities.rivile;

  let validParent = product_suppliers.length > 1;
  let supplier_name = assignSupplierName(
    typeof props.item.supplier == "string"
      ? props.item.supplier
      : props.item.supplier?.name || ""
  );

  const handleSaveVvSku = (productId, vvSku) => {
    console.log(`Saving VV SKU ${vvSku} for product ${productId}`);
    if (props?.refetchProducts) {
      props.refetchProducts();
    }
  };

  const handleCreateVvProduct = (productId) => {
    console.log(`Creating new VV product for ${productId}`);
    if (props?.refetchProducts) {
      props.refetchProducts();
    }
  };

  return (
    <>
      <TableColumnProductStyle
        className="align-middle"
        key={props.item.product_identifier || props.item.sku}
        parentItem={
          props.itsparent ? "#fbfbfb" : validParent ? "#f9f9f9" : "white"
        }
      >
        {props.itsparent ? (
          <>
            <td className="align-middle">
              {props.item.product_identifier || props.item.sku}
            </td>
            <td className="align-middle open"></td>
            <td className="align-middle open"></td>
            <td
              className="align-middle d-flex no-padding-top mr-2"
              style={{ overflow: "hidden" }}
            >
              <>
                <span
                  className="d-flex justify-content-center align-items-center"
                  style={{ width: "120px", height: "30px" }}
                >
                  {props.item.supplier_name}
                </span>
                <ButtomSuplSize
                  style={{ display: "none" }}
                  className="btn"
                  colorLength={"#009BDA"}
                  colorRadius={"#007FB3"}
                >
                  <span className="one"> 10</span>
                  <span className="two">tiekėjai</span>
                  <span className="free">
                    <FaChevronUp />
                  </span>
                </ButtomSuplSize>

                <DivLine style={{ height: "45px", width: "120px!important" }}>
                  <svg
                    width="300"
                    height="100"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="50"
                      x2="50"
                      y1="0"
                      y2="25"
                      stroke="#009BDA"
                      strokeWidth="2"
                    />
                    <line
                      x1="51"
                      x2="100%"
                      y1="25"
                      y2="25"
                      stroke="#009BDA"
                      strokeWidth="2"
                    />
                    {props.total !== props.indexN ? (
                      <line
                        x1="50"
                        x2="50"
                        y1="0"
                        y2="80"
                        stroke="#009BDA"
                        strokeWidth="2"
                      />
                    ) : null}
                  </svg>
                </DivLine>
              </>
            </td>
            <td className="align-middle">
              {props.item.quantity}
              <OnHoldBadge onHoldAt={props.item.on_hold_at} className="ml-1" />
            </td>
            <td className="align-middle">
              {supplier_name === "rivile" ? 0 : props.item.quantity}
            </td>
            <td className="align-middle">
              {supplier_name === "rivile" ? props.item.quantity : 0}
            </td>
            <td className="align-middle">{supplier_name}</td>
            <td className="align-middle">
              {props.item.code || props.item.supplier_code}
            </td>
            <td className="align-middle">
              <span>{returnEuroString(props.item.wholesale_price)}</span>
            </td>
            <td className="align-middle">
              <span>{props.item.invoice_price && returnEuroString(props.item.invoice_price)}</span>
            </td>
            <td className="align-middle">
              <span>{returnEuroString(props.e_price)}</span>
            </td>
            {/* <td className="align-middle">
              <span>{returnEuroString(props.r_price)}</span>
            </td> */}
            <td className="align-middle">
              <span>{returnEuroString(props.wholsale_price)}</span>
            </td>
          </>
        ) : (
          <>
            <td className="align-middle">
              {!!props.onChangeChecked && (
                <Checkbox
                  disabled={props.item.imported}
                  checked={props.checkedIncluded}
                  onChange={props.onChangeChecked}
                >
                  {props.item.sku}
                </Checkbox>
              )}
              {props?.isMassImport ? null : (
                <Tooltip
                  placement="top"
                  title={
                    <span className="text-sm">
                      <div style={{ color: "#fff" }}>
                        {props.item.active
                          ? "Product is active in PIM"
                          : "Product is disabled in PIM"}
                      </div>
                    </span>
                  }
                >
                  <IconDot
                    color={props.item.active ? "#008000" : "#FF0000"}
                    className="text-xl ml-2"
                  />
                </Tooltip>
              )}
              {props.item.identifier}
            </td>
            <td className="align-middle">
              {props.item.vv_sku ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>{props.item.vv_sku}</span>
                  <VvSkuPopover
                    productId={props.item.id}
                    onSave={handleSaveVvSku}
                    onCreateNew={handleCreateVvProduct}
                    currentVvSku={props.item.vv_sku}
                    isEditing={true}
                  />
                </div>
              ) : (
                <VvSkuPopover
                  productId={props.item.id}
                  onSave={handleSaveVvSku}
                  onCreateNew={handleCreateVvProduct}
                />
              )}
            </td>
            <td className="align-middle open">{props.item.title}</td>
            <td className="align-middle d-flex">
              {props.item.hasOwnProperty("product_suppliers") && (
                <>
                  <ButtomSuplSize
                    className="btn"
                    colorLength={
                      product_suppliers.length == 0 ? "#cbcbcb" : "#009BDA"
                    }
                    colorRadius={
                      product_suppliers.length == 0 ? "#b1b1b1" : "#007FB3"
                    }
                    onClick={
                      product_suppliers.length > 0
                        ? () => props.handleToggle(props.item.id)
                        : null
                    }
                  >
                    <span className="one"> {product_suppliers.length}</span>
                    <span className="two">
                      {product_suppliers.length <= 1
                        ? "  supplier"
                        : "  suppliers"}
                    </span>
                    <span className="free">
                      {product_suppliers.length === 0 ? (
                        " "
                      ) : props.openArray.includes(props.item.id) ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </span>
                  </ButtomSuplSize>
                  <DivLine
                    style_hidden={
                      props.openArray.includes(props.item.id)
                        ? "visible"
                        : "hidden"
                    }
                    style={{ height: "1px", width: "1px" }}
                  >
                    <svg
                      width="100"
                      height="100"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <line
                        x1="10"
                        x2="50"
                        y1="20"
                        y2="20"
                        stroke="#009BDA"
                        strokeWidth="2"
                      />
                      <line
                        x1="50"
                        x2="50"
                        y1="20"
                        y2="50"
                        stroke="#009BDA"
                        strokeWidth="2"
                      />
                    </svg>
                  </DivLine>
                </>
              )}
            </td>
            {props.openArray.includes(props.item.id) ? (
              <>
                <td className="align-middle openSilver">Quantity</td>
                <td className="align-middle openSilver">BB</td>
                <td className="align-middle openSilver">VV</td>
                <td className="align-middle openSilver">Department</td>
                <td className="align-middle openSilver">Supplier code</td>
                <td className="align-middle openSilver">Supplier price</td>
                <td className="align-middle openSilver">Invoice price</td>
                <td className="align-middle openSilver">E-price</td>
                {/* <td className="align-middle openSilver">R-price</td> */}
                <td className="align-middle openSilver">Cost-price+PVM</td>
              </>
            ) : (
              <>
                <td className="align-middle">{quantities.other}</td>
                {props?.isMassImport ? null : (
                  <>
                    <td className="align-middle">{quantities.bb}</td>
                    <td className="align-middle">{quantities.rivile}</td>
                  </>
                )}
                <td className="align-middle">
                  {props.item.hasOwnProperty("supplier") && (
                    <span>{supplier_name}</span>
                  )}
                </td>
                <td className="align-middle">
                  {props.item.code || props.item.supplier_code}
                </td>
                <td className="align-middle"></td>
                <td className="align-middle">
                  <span>{returnEuroString(props.item.e_price)}</span>
                </td>
                {/* <td className="align-middle">
                  <span>{returnEuroString(props.item.r_price)}</span>
                </td> */}
                <td className="align-middle">
                  <span>{returnEuroString(props.item.wholsale_price)}</span>
                </td>
                {props?.item?.import_errors && (
                  <td className="align-middle">
                    <span>{props?.item?.import_errors}</span>
                  </td>
                )}
              </>
            )}
          </>
        )}
      </TableColumnProductStyle>

      {props.item.hasOwnProperty("product_suppliers") &&
        props.openArray.includes(props.item.id) &&
        product_suppliers.map((parentItem, index) => (
          <TableColumnProduct
            suppliers={props.suppliers}
            key={index}
            item={parentItem}
            itsparent="true"
            total={product_suppliers.length - 1}
            indexN={index}
            r_price={props.item.r_price}
            e_price={props.item.e_price}
            wholsale_price={props.item.wholsale_price}
          />
        ))}
    </>
  );
}

const DivLine = styled.div`
  width: 120px !important;
  height: 1px;
  visibility: ${(props) => props.style_hidden};
`;

const ButtomSuplSize = styled.button`
  padding: 0;
  margin: 0;
  width: 120px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  color: white;
  background-color: ${(props) => props.colorLength};
  .one {
    background-color: ${(props) => props.colorRadius};
    border-radius: 50%;
  }
  .two {
    margin: 0 4px;
  }
  .free {
    width: 24px;
    border-radius: 20px;
  }
  &:hover {
    color: white;
  }
`;

const TableColumnProductStyle = styled.tr`
  background-color: ${(props) => props.parentItem}!important;

  td {
    font-size: 0.7rem;
    line-height: 0.8rem;
    color: #212121;
    font-weight: 500;
  }
  .openSilver {
    font-weight: 900;
    color: #d2d2d2;
  }
`;

export default TableColumnProduct;
